import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import AsyncReactSelect from 'react-select/async';
import usePotionSelectProps from './use-potion-select-props';
const AsyncSelect = forwardRef((props, ref) => {
    const potionSelectProps = usePotionSelectProps(props);
    return _jsx(AsyncReactSelect, Object.assign({ ref: ref }, potionSelectProps), void 0);
});
export default AsyncSelect;
